import React, { useState } from 'react';
import { MdChevronRight } from 'react-icons/md';
import palette from '../../utils/colorPalette';
import styled from 'styled-components';
import { Typography } from '../atoms';

const Accordion = ({
  title,
  children,
  style,
  headerStyle,
  height,
  initialOpen,
  variant,
  mode,
  contentStyle,
  hover,
}) => {
  const [isOpen, setIsOpen] = useState(!!initialOpen ? initialOpen : false);

  const mergedProps = {
    background: !!mode ? palette.button[mode] : palette.button['default'],
    background_hover: !!mode
      ? palette.buttonHover[mode]
      : palette.buttonHover['default'],
    color: !!mode ? palette.buttonText[mode] : palette.buttonText['default'],
    color_hover: !!hover ? palette.buttonText[hover] : palette.buttonText['default'],
    variant: !!variant ? variant : 'content1',
  };

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <AccordionContainer style={style}>
      <AccordionHeader
        style={headerStyle}
        {...mergedProps}
        onClick={toggleAccordion}
      >
        <Arrow $isopen={isOpen} size={20} />
        <Typography variant={variant}>{title}</Typography>
      </AccordionHeader>
      <AccordionContent style={contentStyle} $isopen={isOpen} $height={height}>
        {children}
      </AccordionContent>
    </AccordionContainer>
  );
};

export default Accordion;

// ------------------------ STYLE ------------------------

const Arrow = styled(MdChevronRight)`
  transition: transform 0.3s ease;
  transform: ${(props) => (props.$isopen ? 'rotate(90deg)' : '0')};
  position: absolute;
  left: 10px;
`;

const AccordionContainer = styled.div`
  //width: 100%;
  overflow: hidden;
`;

const AccordionHeader = styled.div`
  padding: 10px;
  background-color: ${(props) => props.background};
  color: ${(props) => props.color};
  cursor: pointer;
  transition: background-color 0.4s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  &:hover {
    background-color: ${(props) => props.background_hover};
    color: ${(props) => props.color_hover};
  }
`;

const AccordionContent = styled.div`
  height: ${(props) =>
    props.$isopen ? (props.$height ? props.$height : '100px') : '0'};
  overflow: hidden;
  transition: height 0.4s ease;
`;
